module.exports = __webpack_public_path__ + "static/img/mainText.40edbc9f.png";